// Helper function to normalize ZIP codes for ZIP + 4 format
export const normalizeZipCode = (zip) => {
	if (!zip) return "";
	// Convert to string if it's a number
	const zipString = zip.toString();
	// If it contains a hyphen, take the first part, otherwise return the full string
	return zipString.includes("-") ? zipString.split("-")[0] : zipString;
};
